/**
 * Directive: pos
 */
angular.module('acme.common.directive.pos', [])
.directive('pos', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/pos/pos.tpl.html',
      scope: {},
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.pos = "Your spankin new pos!";

      }]

    };

}]);